/* requires:
polyfill.js
*/

// display the current year in the footer
if (document.querySelector('.copyright-year')) {
  document.querySelector('.copyright-year').innerHTML = new Date().getFullYear();
}

// Try to keep the rediredctor API awake and running
// by calling it if 5 minutes has passed since the last call
(function () {
  const apiUrl = '/api/wake-up/';
  const dateNow = Date.now();
  const lastApiCall = sessionStorage.getItem('lastApiCall') ? Number(sessionStorage.getItem('lastApiCall')) : null;
  const wakeApi = async () => {
    try {
      const response = await fetch(apiUrl);
      if (response.ok) {
        const data = await response.text();
        console.log('API:', data);
        // store the current time in sessionStorage
        sessionStorage.setItem('lastApiCall', dateNow);
      } else {
        console.error('Error:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };
  // if the last API call was more than 5 minutes ago, call the API
  if (!lastApiCall || lastApiCall + 300000 < dateNow) {
    wakeApi();
  }
})();

// Modified https://coolcssanimation.com/how-to-trigger-a-css-animation-on-scroll/
function scrollSpy(selector, animationClass, delay) {
  const animationObject = document.querySelectorAll(selector);

  for (let element of animationObject) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (delay !== undefined) {
              setTimeout(function () {
                element.classList.add(animationClass);
              }, delay);
            } else {
              element.classList.add(animationClass);
            }
            return;
          }
        });
      },
      { rootMargin: '-100px' }
    );
    observer.observe(element);
  }
}
